import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { pushProject } from '../apis/projects/pushProject';
import { PdpState } from '../store';

type PushStatus = 'pending' | 'error' | 'ready';

type SnapshotState = {
    pushStatus: PushStatus;
    snapshotIds: string[];
    savedOn?: number;
};

export const { actions, reducer } = createSlice({

    name: 'snapshot',

    initialState: {
        pushStatus: 'ready' as PushStatus,
        snapshotIds: [] as string[]
    } as SnapshotState,

    reducers: {
        initialize: (state, action: PayloadAction<{ savedOn: number }>) => {
            state.savedOn = action.payload.savedOn;
        }
    },

    extraReducers: builder => {

        builder
            .addCase(pushProject.pending, state => void (state.pushStatus = 'pending'))
            .addCase(pushProject.rejected, state => void (state.pushStatus = 'error'));

        builder.addCase(pushProject.fulfilled, (state, action) => {
            state.pushStatus = 'ready';
            state.snapshotIds.push(action.payload.snapshotId);
        });
    }
});

export const selectHasPushError = createSelector([
    (state: PdpState) => state.snapshot.pushStatus
], pushStatus => {
    return pushStatus === 'error';
});